import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import ButtonNew from "../../../common/components/button-new/button-new";
import { ReactComponent as StarIcon } from "../../../assets/icons/star-icon.svg";
import { ReactComponent as Phone } from "../../../assets/icons/phone-ring-yellow.svg";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./PlannerActionButtons.scss";

type Props = {
  email: string;
  phoneNumber: string;
  onReviewClick: () => void;
};

const PlannerActionButtons: React.FC<Props> = ({
  email,
  phoneNumber,
  onReviewClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleEmailClick = () => {
    if (email) {
      window.location.href = `mailto:${email}`;
    } else {
      console.warn("No email provided");
    }
  };

  const handleMessageClick = () => {};

  const handlePhoneClick = () => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      console.warn("No phone number provided");
    }
  };

  const handleReviewsClick = () => {
    onReviewClick();
  };

  const buttonStyle = {
    width: isMobile ? "auto" : undefined,
    padding: isMobile ? "6px" : undefined,
  };

  return (
    <Box className="planner-btns">
      <ButtonNew
        text="Reviews"
        icon={<StarIcon />}
        iconPosition="left"
        bgColor="#bed2d3"
        textColor="#104145"
        borderColor="#15585D"
        onClick={handleReviewsClick}
        iconColor="#E9AE12"
        style={buttonStyle}
      />

      <ButtonNew
        text="Email"
        icon={<MailOutlineIcon fontSize="small" />}
        iconPosition="left"
        bgColor="#bed2d3"
        textColor="#104145"
        borderColor="#15585D"
        onClick={handleEmailClick}
        iconColor="#E9AE12"
        style={buttonStyle}
      />

      {/** Will enable in future */}
      {/* <ButtonNew
        text="Message"
        icon={<ChatBubbleOutlineIcon fontSize="small" />}
        iconPosition="left"
        bgColor="#bed2d3"
        textColor="#104145"
        borderColor="#15585D"
        onClick={handleMessageClick}
        iconColor="#E9AE12"
        style={buttonStyle}
      /> */}

      <ButtonNew
        text="Phone Number"
        icon={<Phone fontSize="small" />}
        iconPosition="left"
        bgColor="#bed2d3"
        textColor="#104145"
        borderColor="#15585D"
        onClick={handlePhoneClick}
        iconColor="#E9AE12"
        style={buttonStyle}
      />
    </Box>
  );
};

export default PlannerActionButtons;
